import { Landing } from '@modules/missions/landing'

export function Mission() {
  return <Landing />
}
